"use client"

import QRCodeButton from "@/components/QRCodeButton"
import ShareButton from "@/components/ShareButton"
import { ReactNode, useEffect, useState } from "react"

export default function SocialsButtons({
  sharingQRCodeSubtitle2,
  sharingQRCodeSubtitle,
  sharingQRCodeUrl,
  sharingQRCodeTitle,
  shareUrl,
  shareUrlTitle,
  providerInstagramReference,
}: {
  sharingQRCodeSubtitle2?: ReactNode
  sharingQRCodeSubtitle?: string
  sharingQRCodeUrl: string
  sharingQRCodeTitle: string
  shareUrl?: string
  shareUrlTitle: string
  providerInstagramReference?: string
}) {
  const [isShareEnabled, setIsShareEnabled] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line
    // @ts-ignore - NOTE:KB - leaving this how I found it
    if (window.navigator?.share) {
      setIsShareEnabled(true)
    }
  }, [])

  return (
    <div
      className={
        "flex w-full flex-row items-center justify-center gap-[20px] pt-[10px]"
      }
    >
      <QRCodeButton
        sharingQRCodeUrl={sharingQRCodeUrl}
        sharingQRCodeTitle={sharingQRCodeTitle}
        sharingQRCodeSubtitle={sharingQRCodeSubtitle}
        sharingQRCodeSubtitle2={sharingQRCodeSubtitle2}
      />

      {isShareEnabled && (
        <ShareButton shareUrl={shareUrl} shareUrlTitle={shareUrlTitle} />
      )}

      {providerInstagramReference && (
        <a
          href={"https://www.instagram.com/" + providerInstagramReference}
          target={"_blank"}
          className={
            "flex h-[40px] w-[40px] items-center justify-center rounded-full bg-[#e8e8e8]"
          }
        >
          <img
            width={20}
            height={20}
            src={"/instagram.svg"}
            alt={"instagram"}
          />
        </a>
      )}
    </div>
  )
}
